import { useTranslation } from 'next-i18next';
import { FAQ } from '@/widgets/FAQ';
import { ProductType } from '@/entities/product';
import { JsonLdDecorator, MetaDecorator } from '@/shared/utils';
import { getQuestions } from '../lib/faqs';
import CardsBenefitsBlock from './CardsBenefitsBlock';
import HeroBlock from './HeroBlock';
import HowItWorksBlock from './HowItWorksBlock';
import ProductBlock from './ProductBlock/ProductBlock';
import ProductsBlock from './ProductsBlock';
import UseCaseBlock from './UseCaseBlock';

interface ProductGoogleReviewCardPageProps {
  product: ProductType;
  products: ProductType[];
}

const StoreProduct = ({ product, products }: ProductGoogleReviewCardPageProps) => {
  const { t } = useTranslation();
  const questions = getQuestions(t);

  const productName = product.name;
  const title = `${productName} | LocalProf`;
  const description =
    (product.description as string) ||
    t('storeProduct.defaultDescription' as string, { productName });

  return (
    <>
      <MetaDecorator
        description={description || ''}
        title={title}
      />
      <JsonLdDecorator faqList={questions} />

      <HeroBlock
        heroContent={product.heroContent}
        productType={product.type}
        src={product.heroVideo?.src}
        srcFallback={product.heroVideo?.srcFallback}
      />
      <ProductBlock product={product} />
      <CardsBenefitsBlock />
      <HowItWorksBlock description={product.howItWorksDescription} />
      <UseCaseBlock />
      <ProductsBlock products={products} />
      <FAQ questions={questions} />
    </>
  );
};

export default StoreProduct;
